// src/pages/MyOrders.js
import React, { useState } from "react";
import { getOrdersByEmail, getOrder } from "../utils/firestoreService";
import toast from "react-hot-toast";

const STATUS_LABELS = {
  pending: "⏳ Pendiente",
  confirmed: "✅ Confirmado",
  preparing: "🖨️ En producción",
  shipped: "🚚 Enviado",
  delivered: "📦 Entregado",
  cancelled: "❌ Cancelado"
};

export default function MyOrders() {
  const [email, setEmail] = useState("");
  const [orderId, setOrderId] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [mode, setMode] = useState("email");

  const formatPrice = p =>
    new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 }).format(p);

  const searchByEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const results = await getOrdersByEmail(email);
      setOrders(results);
      setSearched(true);
      if (results.length === 0) toast("No encontramos pedidos con ese email");
    } catch {
      toast.error("Error al buscar pedidos");
    } finally {
      setLoading(false);
    }
  };

  const searchById = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const order = await getOrder(orderId.trim());
      if (order) { setOrders([order]); setSearched(true); }
      else { toast("No se encontró ese número de pedido"); setOrders([]); setSearched(true); }
    } catch {
      toast.error("Error al buscar pedido");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-pad content-page">
      <h1>Mis pedidos</h1>
      <p>Rastrea el estado de tus pedidos.</p>

      <div className="orders-search">
        <div className="mode-tabs">
          <button className={mode === "email" ? "active" : ""} onClick={() => setMode("email")}>Buscar por email</button>
          <button className={mode === "id" ? "active" : ""} onClick={() => setMode("id")}>Buscar por # pedido</button>
        </div>

        {mode === "email" ? (
          <form onSubmit={searchByEmail} className="search-form">
            <input type="email" required placeholder="tucorreo@email.com" value={email} onChange={e => setEmail(e.target.value)} />
            <button type="submit" className="btn-primary" disabled={loading}>{loading ? "Buscando..." : "Buscar"}</button>
          </form>
        ) : (
          <form onSubmit={searchById} className="search-form">
            <input required placeholder="ID del pedido (del correo de confirmación)" value={orderId} onChange={e => setOrderId(e.target.value)} />
            <button type="submit" className="btn-primary" disabled={loading}>{loading ? "Buscando..." : "Buscar"}</button>
          </form>
        )}
      </div>

      {searched && (
        <div className="orders-results">
          {orders.length === 0 ? (
            <div className="empty-state"><p>No se encontraron pedidos.</p></div>
          ) : (
            orders.map(order => (
              <div key={order.id} className="order-card">
                <div className="order-card-header">
                  <div>
                    <strong>Pedido #{order.id.slice(0,8).toUpperCase()}</strong>
                    <span>{order.createdAt?.toDate?.().toLocaleDateString("es-CO") || "—"}</span>
                  </div>
                  <span className={`status-chip status-${order.status}`}>{STATUS_LABELS[order.status]}</span>
                </div>
                <div className="order-card-items">
                  {order.items?.map((item, i) => (
                    <div key={i} className="oc-item">
                      {item.image && <img src={item.image} alt={item.name} />}
                      <span>{item.name} x{item.quantity}</span>
                      <span>{formatPrice(item.price * item.quantity)}</span>
                    </div>
                  ))}
                </div>
                <div className="order-card-total">
                  <span>Total:</span>
                  <strong>{formatPrice(order.total)}</strong>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
